/**
 * Zod Schemas for Storage Domain Types
 *
 * Provides runtime validation schemas for StoredSnapshot, StoredMeta,
 * VersionInfo, and MigrationRecord.
 *
 * @module schemas/storage.zod
 * @see Requirements 2.1, 2.2
 */
import { z } from 'zod';
import { DocACLSchema } from './acl.zod';
/**
 * Schema for StoredSnapshot - document snapshot in Redis.
 * Validates content, compression flag, hash, and timestamp.
 */
export const StoredSnapshotSchema = z.object({
    content: z.string(),
    compressed: z.boolean(),
    contentHash: z.string().min(1),
    storedAt: z.number().int().positive(),
});
/**
 * Schema for StoredMeta - document metadata in Redis.
 * Validates all required fields including ACL.
 */
export const StoredMetaSchema = z.object({
    docId: z.string().min(1),
    title: z.string().min(1),
    ownerId: z.string().min(1),
    createdAt: z.number().int().positive(),
    updatedAt: z.number().int().positive(),
    acl: DocACLSchema,
    frontmatter: z.record(z.unknown()).optional(),
});
/**
 * Schema for VersionInfo - version history entry.
 * Validates versionId, timestamp, and optional summary.
 */
export const VersionInfoSchema = z.object({
    versionId: z.string().min(1),
    updatedAt: z.number().int().positive(),
    summary: z.string().optional(),
});
/**
 * Schema for MigrationRecord - migration execution record.
 * Validates sequence, name, timestamp, and status.
 */
export const MigrationRecordSchema = z.object({
    sequence: z.number().int().positive(),
    name: z.string().min(1),
    executedAt: z.string().datetime(),
    status: z.enum(['success', 'failed']),
});
//# sourceMappingURL=storage.zod.js.map